import { Component, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';

interface ConfigFinancasMenuItem {
  label: string;
  route: string;
  icon: string;
}

interface ConfigFinancasMenuGroup {
  title: string;
  items: ConfigFinancasMenuItem[];
}

@Component({
  selector: 'app-config-financas',
  standalone: true,
  imports: [
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTabsModule,
    HeaderComponent,
    EmptyListComponent,
    MatButtonModule,
    ReactiveFormsModule,
  ],
  templateUrl: './config-financas.component.html',
  styleUrls: ['./config-financas.component.css'],
})
export class ConfigFinancasComponent implements OnInit {
  public moduloEnum = ModuloEnum.Configuracoes;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Financas;

  public menuGroups: ConfigFinancasMenuGroup[] = [
    {
      title: 'Geral',
      items: [
        { label: 'Gerais', route: 'gerais', icon: 'settings' },
        { label: 'Campos obrigatórios', route: 'campos-obrigatorios', icon: 'rule' },
      ],
    },
    {
      title: 'Contas financeiras',
      items: [{ label: 'Contas financeiras', route: 'contas-financeiras', icon: 'account_balance_wallet' }],
    },
    {
      title: 'Contas a pagar e a receber',
      items: [
        { label: 'Contas a pagar', route: 'contas-pagar', icon: 'arrow_circle_up' },
        { label: 'Contas a receber', route: 'contas-receber', icon: 'arrow_circle_down' },
      ],
    },
    {
      title: 'Pagamentos e recebimentos',
      items: [
        { label: 'Formas de pagamento', route: 'formas-pagamento', icon: 'payments' },
        { label: 'Formas de recebimento', route: 'formas-recebimento', icon: 'point_of_sale' },
        { label: 'Intermediadores de pagamento', route: 'intermediador-pagamento', icon: 'hub' },
        { label: 'Condições de pagamento', route: 'condicoes-pagamento', icon: 'event_repeat' },
      ],
    },
    {
      title: 'Centros de custo',
      items: [
        { label: 'Centros de custo', route: 'centros-custo', icon: 'account_tree' },
        { label: 'Rateios de centro de custo', route: 'rateios-centro-custo', icon: 'call_split' },
      ],
    },
    {
      title: 'Categorias e tags',
      items: [
        { label: 'Categorias financeiras', route: 'categorias', icon: 'category' },
        { label: 'Categorias financeiras padrão', route: 'categorias-padrao', icon: 'stars' },
        { label: 'Tags de movimentação', route: 'tags-movimentacao', icon: 'sell' },
        { label: 'Tags de contas a pagar', route: 'tags-contas-pagar', icon: 'local_offer' },
        { label: 'Tags de contas a receber', route: 'tags-contas-receber', icon: 'loyalty' },
      ],
    },
    {
      title: 'Documentos',
      items: [{ label: 'Envio de documentos', route: 'envio-documentos', icon: 'send' }],
    },
  ];

  public filteredMenuGroups: ConfigFinancasMenuGroup[] = [...this.menuGroups];
  public pesquisaControl = new FormControl('');

  ngOnInit(): void {
    this.pesquisaControl.valueChanges.subscribe(() => {
      this.filtrar();
    });
    this.filtrar();
  }

  public filtrar(): void {
    const termo = this.removeAcentos(this.pesquisaControl.value?.toLowerCase() || '');
    if (!termo) {
      this.filteredMenuGroups = [...this.menuGroups];
      return;
    }

    this.filteredMenuGroups = this.menuGroups
      .map(group => {
        const groupMatches = this.removeAcentos(group.title.toLowerCase()).includes(termo);
        const items = groupMatches
          ? group.items
          : group.items.filter(item => this.removeAcentos(item.label.toLowerCase()).includes(termo));

        return { ...group, items };
      })
      .filter(group => group.items.length > 0);
  }

  public get nenhumResultado(): boolean {
    return this.filteredMenuGroups.length === 0;
  }

  private removeAcentos(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
}
